module.exports = "/assets/677d3fe181e98bffb1dd7137cf91a272.svg";